<div class="internal" id="main">
  <div class="section third-part-reservation" id="third-part-reservation">
    <div class="content-body">
      <div class="title">
        <h1>{{ "third_party_reservation.title" | translate }}</h1>
      </div>
      <div class="content">
        <form [formGroup]="form" class="form" (submit)="onSubmit()">
          <div class="search">
            <div class="fieldset">
              <label for="bookings">{{
                "third_party_reservation.select_ship" | translate
              }}</label>
              <p-select
                formControlName="ship"
                [filter]="true"
                [options]="ships"
                [style]="{ width: '100%' }"
                optionLabel="name"
                placeholder="{{
                  'third_party_reservation.select_ship' | translate
                }}"
                (onChange)="onShipChange($event)"
              />
            </div>
          </div>
          <div class="search">
            <div class="fieldset">
              <label for="cabin_number">{{
                "third_party_reservation.cabin_number" | translate
              }}</label>
              <p-select
                formControlName="cabinNumber"
                [options]="cabins"
                [filter]="true"
                [style]="{ width: '100%' }"
              />
            </div>
          </div>
          <div class="buttons">
            @if (!loaded) {
            <button class="costa-button outline" type="button" (click)="Back()">
              {{ "cancel" | translate }}
            </button>
            }
            <button class="costa-button" [disabled]="!form.valid" type="submit">
              {{ "search" | translate }}
            </button>
          </div>
        </form>
        @if (passengerList.length > 0) {
        <p>{{ "third_party_reservation.select_passenger" | translate }}</p>
        <app-passenger-selection
          (selectionChange)="onPassengersSelected($event)"
          [multiSelect]="false"
          [passengers]="passengerList"
        ></app-passenger-selection>
        <div class="buttons">
          <button class="costa-button outline" type="button" (click)="Back()">
            {{ "cancel" | translate }}
          </button>
          <button
            [disabled]="selectedPassenger == null"
            (click)="ConfirmSelection()"
            class="costa-button outline w-50"
            type="button"
          >
            {{ "confirm" | translate }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>
